"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSHA256 = exports.downloadExtractAndCacheJDK = exports.downloadAndExtractJDK = exports.getLatestRelease = exports.exec = void 0;
const c = __importStar(require("./constants"));
const core = __importStar(require("@actions/core"));
const httpClient = __importStar(require("@actions/http-client"));
const tc = __importStar(require("@actions/tool-cache"));
const exec_1 = require("@actions/exec");
const fs_1 = require("fs");
const core_1 = require("@octokit/core");
const crypto_1 = require("crypto");
const path_1 = require("path");
// Set up Octokit in the same way as @actions/github (see https://git.io/Jy9YP)
const baseUrl = process.env['GITHUB_API_URL'] || 'https://api.github.com';
const GitHub = core_1.Octokit.defaults({
    baseUrl,
    request: {
        agent: new httpClient.HttpClient().getAgent(baseUrl)
    }
});
function exec(commandLine, args, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const exitCode = yield (0, exec_1.exec)(commandLine, args, options);
        if (exitCode !== 0) {
            throw new Error(`'${[commandLine]
                .concat(args || [])
                .join(' ')}' exited with a non-zero code: ${exitCode}`);
        }
    });
}
exports.exec = exec;
function getLatestRelease(repo) {
    return __awaiter(this, void 0, void 0, function* () {
        const githubToken = core.getInput('github-token');
        const options = githubToken.length > 0 ? { auth: githubToken } : {};
        const octokit = new GitHub(options);
        return (yield octokit.request('GET /repos/{owner}/{repo}/releases/latest', {
            owner: c.GRAALVM_GH_USER,
            repo
        })).data;
    });
}
exports.getLatestRelease = getLatestRelease;
function downloadAndExtractJDK(downloadUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        return findJavaHomeInSubfolder(yield extract(yield tc.downloadTool(downloadUrl)));
    });
}
exports.downloadAndExtractJDK = downloadAndExtractJDK;
function downloadExtractAndCacheJDK(downloader, toolName, version) {
    return __awaiter(this, void 0, void 0, function* () {
        const semVersion = toSemVer(version);
        let toolPath = tc.find(toolName, semVersion);
        if (toolPath) {
            core.info(`Found ${toolName} ${version} in tool-cache @ ${toolPath}`);
        }
        else {
            const extractDir = yield extract(yield downloader());
            core.info(`Adding ${toolName} ${version} to tool-cache ...`);
            toolPath = yield tc.cacheDir(extractDir, toolName, semVersion);
        }
        return findJavaHomeInSubfolder(toolPath);
    });
}
exports.downloadExtractAndCacheJDK = downloadExtractAndCacheJDK;
function calculateSHA256(filePath) {
    const hashSum = (0, crypto_1.createHash)('sha256');
    hashSum.update((0, fs_1.readFileSync)(filePath));
    return hashSum.digest('hex');
}
exports.calculateSHA256 = calculateSHA256;
function extract(downloadPath) {
    return __awaiter(this, void 0, void 0, function* () {
        if (c.GRAALVM_FILE_EXTENSION === '.tar.gz') {
            return yield tc.extractTar(downloadPath);
        }
        else if (c.GRAALVM_FILE_EXTENSION === '.zip') {
            return yield tc.extractZip(downloadPath);
        }
        else {
            throw new Error(`Unexpected filetype downloaded: ${c.GRAALVM_FILE_EXTENSION}`);
        }
    });
}
function findJavaHomeInSubfolder(searchPath) {
    const baseContents = (0, fs_1.readdirSync)(searchPath);
    if (baseContents.length === 1) {
        return (0, path_1.join)(searchPath, baseContents[0], c.JDK_HOME_SUFFIX);
    }
    else {
        throw new Error(`Unexpected amount of directory items found: ${baseContents.length}`);
    }
}
/**
 * This helper turns GraalVM version numbers (e.g., `22.0.0.2`) into valid
 * semver.org versions (e.g., `22.0.0-2`), which is needed because
 * @actions/tool-cache uses `semver` to validate versions.
 */
function toSemVer(version) {
    const parts = version.split('.');
    const major = parts[0];
    const minor = parts.length > 1 ? parts[1] : '0';
    const patch = parts.length > 2 ? parts.slice(2).join('-') : '0';
    return `${major}.${minor}.${patch}`;
}
